export default {
  data () {
    return {
      statementRequest: {
        resource: 'ag.practitioner.statement.3.1'
      },
      statementTimeout: null,
      statementTimeoutDelay: 1000
    }
  },
  computed: {
    medicalAid () {
      return this.getObjectPath(this.request, 'result.invoice.medical_aid', null)
    },
    billingContact () {
      return this.getObjectPath(this.request, 'result.invoice.billing.contact', null)
    },
    statementAppointments () {
      let statementAppointments = this.getObjectPath(this.statementRequest, 'result.results', null)
      if (!statementAppointments && this.appointments) {
        return this.appointments
      }
      return statementAppointments
    },
    statementRequestStatus () {
      return this.statementRequest.status
    },
    currency () {
      if (this.statementAppointments && this.statementAppointments.length > 0) {
        return this.statementAppointments[0].currency
      }
      return this.defaultCurrency
    }
  },
  methods: {
    debouncedGetStatement () {
      // this.statementRequest.loading = true
      if (this.statementTimeout) {
        window.clearTimeout(this.statementTimeout)
        this.statementTimeout = window.setTimeout(this.getStatement, this.statementTimeoutDelay)
      } else {
        this.statementTimeout = window.setTimeout(this.getStatement, 0)
      }
      // window.setTimeout(() => {
      //   if (this.statementTimeout) {
      //     console.log('clearing')
      //     this.statementTimeout = null
      //   }
      // }, 10000)
    },
    getStatement () {
      if (this.appointmentIds && this.appointmentIds.length > 0) {
        let appointmentIds = this.appointmentIds.join(',')
        this.statementRequest.params = {
          appointments: appointmentIds,
          ordering: 'start_time'
        }
        this.$request('get', this.statementRequest)
      } else {
        console.error('this.appointmentIds not defined')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/statement.js